import './apple/style';
import FormStructure from './apple/form_structure';

export default FormStructure;